const prefix = "st.stss.";

export const STORAGE_KEYS = {
  LPT_SELECTED_LANGUAGE: prefix + "lpt.preferred_user_language",
  ALLOW_DEV_LOGS: "allowDevLogs",
};
